import { render, staticRenderFns } from "./AddPurchaseInvoiceHeader.vue?vue&type=template&id=3f8fc75f&scoped=true&"
import script from "./AddPurchaseInvoiceHeader.vue?vue&type=script&lang=js&"
export * from "./AddPurchaseInvoiceHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8fc75f",
  null
  
)

export default component.exports